import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { AlertService } from '../../services/alert.service';
import { FirmwareService } from '../../services/firmware.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'firmware-v1',
    templateUrl: './firmware-v1.component.html',
    styleUrls: ['./firmware-v1.component.scss']
})
export class FirmwareV1Component implements OnInit, OnDestroy, OnChanges {

    @Input()
    product: any;

    newFirmwareVisible!: boolean;

    newFirmwareFormGroup!: FormGroup;

    newFirmwareSelectedFile!: File | null;

    lastFirmwaresForTestUsers: any;

    lastFirmwaresForBetaUsers: any;

    lastFirmwaresForEndUsers: any;

    firmwares!: any[];

    user: any;

    selectedFirmwareToEdit: any;

    editFirmwareFormGroup: any;

    deleteFirmwareVisibles: any = {};

    firmwareCompare = (a: any, b: any) => {
        if (a.name != b.name) {
            return a.name.localeCompare(b.name);
        } else {
            return -a.version + b.version;
        }
    };

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private firmwareService: FirmwareService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newFirmwareFormGroup = this.formBuilder.group({
            newFirmwareNameInput: [null, Validators.required],
            newFirmwareFileInput: [null, Validators.required],
            newFirmwareVersionTXTInput: [null, Validators.required],
            newFirmwareVersionInput: [null, Validators.required],
            newFirmwareMinVersionInput: [null, /*Validators.required*/],
            newFirmwareMD5Input: [null, /*Validators.required*/],
            newFirmwareForceSelect: [{ value: 'false', disabled: false }, Validators.required]
        });
        this.newFirmwareSelectedFile = null;
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refreshFirmwares();
    }

    displayNewFirmwareFormGroup() {
        if (this.newFirmwareFormGroup) {
            this.newFirmwareFormGroup.reset();
        }
        this.newFirmwareSelectedFile = null;
        this.newFirmwareVisible = true;
        this.cancelSelectedFirmwareToEdit();
    }

    hideNewFirmwareFormGroup() {
        if (this.newFirmwareFormGroup) {
            this.newFirmwareFormGroup.reset();
        }
        this.newFirmwareSelectedFile = null;
        this.newFirmwareVisible = false;
    }

    refreshFirmwares() {
        this.deleteFirmwareVisibles = {};
        this.hideNewFirmwareFormGroup();
        this.cancelSelectedFirmwareToEdit();
        this.getFirmwares();
    }

    getFirmwares() {
        this.progressIndicatorService.progress = true;
        forkJoin([
            this.firmwareService.getLastProductFirmwaresForTestUsers(this.product.name),
            this.firmwareService.getLastProductFirmwaresForBetaUsers(this.product.name),
            this.firmwareService.getLastProductFirmwaresForEndUsers(this.product.name),
            this.firmwareService.getAllFirmwares(this.product.name),
            this.firmwareService.checkToken()
        ]).subscribe({
            next: ([lastFirmwaresForTestUsers, lastFirmwaresForBetaUsers, lastFirmwaresForEndUsers, firmwares, user]) => {
                console.log('FirmwareV1Component.getFirmwares.firmwareService.getLastProductFirmwaresForTestUsers.value', lastFirmwaresForTestUsers);
                console.log('FirmwareV1Component.getFirmwares.firmwareService.getLastProductFirmwaresForBetaUsers.value', lastFirmwaresForBetaUsers);
                console.log('FirmwareV1Component.getFirmwares.firmwareService.getLastProductFirmwaresForEndUsers.value', lastFirmwaresForEndUsers);
                console.log('FirmwareV1Component.getFirmwares.firmwareService.getAllFirmwares.value', firmwares);
                console.log('FirmwareV1Component.getFirmwares.firmwareService.checkToken.value', user);
                this.progressIndicatorService.progress = false;

                this.lastFirmwaresForTestUsers = lastFirmwaresForTestUsers;
                this.lastFirmwaresForBetaUsers = lastFirmwaresForBetaUsers;
                this.lastFirmwaresForEndUsers = lastFirmwaresForEndUsers;
                this.firmwares = firmwares;

                this.lastFirmwaresForTestUsers.firmwares.sort(this.firmwareCompare);
                this.lastFirmwaresForBetaUsers.firmwares.sort(this.firmwareCompare);
                this.lastFirmwaresForEndUsers.firmwares.sort(this.firmwareCompare);
                this.firmwares.sort(this.firmwareCompare);

                this.user = user;

            },
            error: (error: any) => {
                console.log('FirmwareV1Component.getFirmwares.firmwareService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    newFirmwareFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newFirmwareSelectedFile = file;
    }

    uploadNewFirmware() {

        let formGroup: FormGroup = this.newFirmwareFormGroup;
        let name: string = formGroup.value.newFirmwareNameInput;
        let version: number = formGroup.value.newFirmwareVersionInput;
        let minVersion: number = formGroup.value.newFirmwareMinVersionInput;
        let versiontTxt: string = formGroup.value.newFirmwareVersionTXTInput;
        let md5: string = formGroup.value.newFirmwareMD5Input || '';
        let force: boolean = formGroup.value.newFirmwareForceSelect === 'true';
        let file: File | null = this.newFirmwareSelectedFile;
        if (file == null) return;

        this.progressIndicatorService.progress = true;
        this.firmwareService.uploadFirmware(file).subscribe({
            next: (value: any) => {
                console.log('FirmwareV1Component.uploadNewFirmware.firmwareService.uploadFirmware.value', value);
                this.progressIndicatorService.progress = false;

                let firmwareId: number = value.id;
                let productId: number = this.product.id;

                this.progressIndicatorService.progress = true;
                this.firmwareService.postFirmwareMetadata(firmwareId, productId, name, version, minVersion, versiontTxt, md5, force).subscribe({
                    next: (value: any) => {
                        console.log('FirmwareV1Component.uploadNewFirmware.firmwareService.postFirmwareMetadata.value', value);
                        this.progressIndicatorService.progress = false;
                        this.alertService.success('Success');
                        this.refreshFirmwares();
                    },
                    error: (error: any) => {
                        console.log('FirmwareV1Component.uploadNewFirmware.firmwareService.postFirmwareMetadata.error', error);
                        this.progressIndicatorService.progress = false;
                        this.alertService.danger('Error');
                    }
                });
            },
            error: (error: any) => {
                console.log('FirmwareV1Component.uploadNewFirmware.firmwareService.uploadFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    validateFirmware(firmwareId: number) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.validateFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV1Component.validateFirmware.firmwareService.validateFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV1Component.validateFirmware.firmwareService.validateFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    publishFirmware(firmwareId: number) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.publishFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV1Component.publishFirmware.firmwareService.publishFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV1Component.publishFirmware.firmwareService.publishFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    displaySelectedFirmwareToEdit(firmwareId: number) {
        let firmware: any = this.firmwares.find((f: any) => f.id == firmwareId);
        if (firmware) {
            this.selectedFirmwareToEdit = firmware;
            this.editFirmwareFormGroup = this.formBuilder.group({
                editFirmwareNameInput: [{ value: firmware.name, disabled: false }, Validators.required],
                editFirmwareFileInput: [{ value: firmware.fileName, disabled: true }, /*Validators.required*/],
                editFirmwareVersionTXTInput: [{ value: firmware.versionTxt, disabled: false }, Validators.required],
                editFirmwareVersionInput: [{ value: firmware.version, disabled: false }, Validators.required],
                editFirmwareMinVersionInput: [{ value: firmware.minVersion, disabled: false }, /*Validators.required*/],
                editFirmwareMD5Input: [{ value: firmware.md5, disabled: false }, /*Validators.required*/],
                editFirmwareForceSelect: [{ value: firmware.force, disabled: false }, Validators.required]
            });
        } else {
            this.selectedFirmwareToEdit = null;
            this.editFirmwareFormGroup = null;
        }
        this.hideNewFirmwareFormGroup();
    }

    updateSelectedFirmwareToEdit() {

        let firmwareId: number = this.selectedFirmwareToEdit.id;
        let productId: number = this.selectedFirmwareToEdit.productId;

        let formGroup: FormGroup = this.editFirmwareFormGroup;
        let name: string = formGroup.value.editFirmwareNameInput;
        let version: number = formGroup.value.editFirmwareVersionInput;
        let minVersion: number = formGroup.value.editFirmwareMinVersionInput;
        let versiontTxt: string = formGroup.value.editFirmwareVersionTXTInput;
        let md5: string = formGroup.value.editFirmwareMD5Input || '';
        let force: boolean = formGroup.value.editFirmwareForceSelect === 'true';

        this.progressIndicatorService.progress = true;
        this.firmwareService.postFirmwareMetadata(firmwareId, productId, name, version, minVersion, versiontTxt, md5, force).subscribe({
            next: (value: any) => {
                console.log('FirmwareV1Component.updateSelectedFirmwareToEdit.firmwareService.postFirmwareMetadata.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.selectedFirmwareToEdit = null;
                this.editFirmwareFormGroup = null;
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV1Component.updateSelectedFirmwareToEdit.firmwareService.postFirmwareMetadata.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    cancelSelectedFirmwareToEdit() {
        this.selectedFirmwareToEdit = null;
        this.editFirmwareFormGroup = null;
    }

    displayDeleteFirmware(firmwareId: number) {
        this.deleteFirmwareVisibles[firmwareId] = true;
        setTimeout(() => this.deleteFirmwareVisibles[firmwareId] = false, 3000);
    }

    deleteFirmware(firmwareId: number) {
        this.progressIndicatorService.progress = true;
        this.firmwareService.deleteFirmware(firmwareId).subscribe({
            next: (value: any) => {
                console.log('FirmwareV1Component.deleteFirmware.firmwareService.deleteFirmware.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshFirmwares();
            },
            error: (error: any) => {
                console.log('FirmwareV1Component.deleteFirmware.firmwareService.deleteFirmware.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
